module.exports = __webpack_public_path__ + "static/where-good-ideas-come-from-b0b1988ac1830a1c115623c4d63f2772.jpg";